import { render, staticRenderFns } from "./allQualityTest.vue?vue&type=template&id=0a6cdc60"
import script from "./allQualityTest.vue?vue&type=script&lang=ts"
export * from "./allQualityTest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports